import { useState } from 'react';
import { useOnboardingStore } from '@/store/onboardingStore';
import { TextureButton } from '@/components/ui/TextureButton';
import type { ActivityLevel } from '@/types/onboarding';

const WEIGHT_CLASSES = ['106', '113', '120', '126', '132', '138', '144', '150', '157', '165', '175', '190', '215', '285'];

export function WeightScreen() {
    const { profile, setPhysicalStats, nextStep } = useOnboardingStore();

    const [height, setHeight] = useState(profile.height || '');
    const [weight, setWeight] = useState(profile.weight || '');
    const [wClass, setWClass] = useState(profile.weightClass || '');
    const [activity, setActivity] = useState<ActivityLevel>(profile.activityLevel || 'athlete');

    const handleContinue = () => {
        setPhysicalStats(height, Number(weight), wClass, activity);
        nextStep();
    };

    return (
        <div className="px-2 animate-fade-in-right space-y-6">
            <h2 className="text-xl font-bold text-text-primary">Weight Management</h2>

            <div className="grid grid-cols-2 gap-4">
                <div className="space-y-1">
                    <label className="text-[10px] uppercase font-bold text-text-muted ml-1">Height (ft'in")</label>
                    <input
                        type="text"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        placeholder="5'8"
                        className="w-full bg-white/5 border border-white/10 rounded-xl py-3 px-4 text-white focus:outline-none focus:border-gold-500"
                    />
                </div>
                <div className="space-y-1">
                    <label className="text-[10px] uppercase font-bold text-text-muted ml-1">Walking Wt (lbs)</label>
                    <input
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(Number(e.target.value))}
                        placeholder="145"
                        className="w-full bg-white/5 border border-white/10 rounded-xl py-3 px-4 text-white focus:outline-none focus:border-gold-500"
                    />
                </div>
            </div>

            <div className="space-y-2">
                <label className="text-[10px] uppercase font-bold text-text-muted ml-1">Target Weight Class</label>
                <div className="grid grid-cols-4 gap-2">
                    {WEIGHT_CLASSES.map((wc) => (
                        <button
                            key={wc}
                            onClick={() => setWClass(wc)}
                            className={`py-2 rounded-lg text-xs font-bold border transition-all ${wClass === wc
                                ? 'bg-gold-500 text-bg border-gold-500'
                                : 'bg-white/5 border-white/10 text-text-muted hover:bg-white/10'
                                }`}
                        >
                            {wc}
                        </button>
                    ))}
                </div>
            </div>

            <div className="space-y-2">
                <label className="text-[10px] uppercase font-bold text-text-muted ml-1">Daily Activity Level</label>
                <div className="grid grid-cols-3 gap-2">
                    {(['sedentary', 'active', 'athlete'] as const).map((lvl) => (
                        <button
                            key={lvl}
                            onClick={() => setActivity(lvl)}
                            className={`py-3 rounded-lg text-[10px] uppercase font-bold border transition-all ${activity === lvl
                                ? 'bg-gold-500/10 border-gold-500 text-gold-500'
                                : 'bg-white/5 border-white/10 text-text-muted hover:bg-white/10'
                                }`}
                        >
                            {lvl}
                        </button>
                    ))}
                </div>
            </div>

            <TextureButton onClick={handleContinue} className="w-full pt-4">
                Next Step
            </TextureButton>
        </div>
    );
}
